<template>
  <div class="page">
    <div class="background-left" :style="{ 'background-image': background }">
      <nav style="margin-left: 15vw; margin-top: 2vh">
        <button
          @click="active_in = 0"
          class="page-content-button"
          :class="{ 'page-content-button-active': active_in == 0 }"
        >
          首页
        </button>
        <!-- <button
          @click="active_in=1"
          class="page-content-button"
          :class="{'page-content-button-active':active_in==1}"
        >账户充值</button> -->
        <!-- <a class="page-content-button" href="https://m.taowoapp.com/wallet/deposit">账户充值</a> -->
        <button
          class="page-content-button"
          :class="{ 'page-content-button-active': active_in == 1 }"
          @click="active_in = 1"
        >
          账户充值
        </button>
        <button
          @click="active_in = 2"
          class="page-content-button"
          :class="{ 'page-content-button-active': active_in == 2 }"
        >
          网络表演
        </button>
        <button
          @click="active_in = 4"
          class="page-content-button"
          :class="{ 'page-content-button-active': active_in == 4 }"
        >
          资讯
        </button>

        <!-- <a class="page-content-button" href="https://m.taowoapp.com/login?redirect=%2Fprofile">账户</a> -->
        <!-- <a class="page-content-button" href="https://m.taowoapp.com">其它分类</a> -->
        <button
          @click="$router.push({ name: 'info' })"
          class="page-content-button"
          :class="{ 'page-content-button-active': active_in == 3 }"
        >
          关于我们
        </button>
        <!-- <button
          @click="$router.push({ name: 'banquan' })"
          class="page-content-button"
          :class="{ 'page-content-button-active': active_in == 5 }"
        >
          版权协议
        </button> -->
      </nav>

      <transition name="fade">
        <div class="index-content" v-show="active_in == 0">
          <img :src="logo" style="margin-bottom: 30px; height: 232px" />
          <h1 style="margin-bottom: 30px">{{ webTitle }}</h1>
          <!-- <h3 style="margin-bottom: 30px">时 · 间 · 交 · 易</h3>
          <p style="width: 35vw; margin-bottom: 60px">
            在{{
              webTitle
            }}，可以下单与人玩游戏、咨询等，也可以方便地创建订单来赚取收入。快来淘我吧~
          </p> -->
          <!-- <button class="download-button" @click="download_click">立即下载</button> -->
          <div class="download-group">
            <div class="qrcode-download" id="qrcode"></div>
            <div class="other-download">
              <!-- <button
                class="download-button ios-download"
                :style="{ 'color': downColor }"
                @click="download_click"
              >
                <i class="font_family icon-download_apple" />ios下载
              </button> -->
              <button
                class="download-button android-download"
                :style="{ color: downColor }"
                @click="download_click"
              >
                <i class="font_family icon-download_android" />
                Adnroid 下载
              </button>
            </div>
          </div>
          <img :src="mobile" class="iphone" />
        </div>
      </transition>

      <transition name="fade">
        <div class="deposit" v-show="active_in == 1">
          <label>请选择购买金额</label>
          <div class="deposit-list" style="margin-top: 10px">
            <div
              class="deposit-list-item"
              v-for="item in coin_num"
              :key="item"
              @click="coin_active = item"
              :class="{ 'deposit-list-item-active': coin_active == item }"
              style="cursor: pointer"
            >
              <span style="left: 2.3vw; position: absolute">{{ item }}</span>
              <span style="right: 10px; position: absolute">¥{{ item }}</span>
            </div>
            <input
              class="deposit-list-item deposit-list-custom"
              placeholder="请输入充值金额"
              style="font-size: 1vw"
              @click="coin_active = -2"
              type="tel"
              v-model="customCharge"
            />
          </div>
          <label>充值账号</label>
          <input
            class="deposit-list-item deposit-phone"
            placeholder="请输入手机号"
            type="tel"
            style="margin-top: 10px; font-size: 1vw"
            v-model="chargePhone"
          />
          <label>选择支付方式</label>
          <div style="margin-top: 10px">
            <el-button
              type="success"
              round
              :style="{ opacity: depositType == 0 ? 1 : 0.5 }"
              @click="depositType = 0"
              >微信</el-button
            >
            <el-button
              type="primary"
              round
              :style="{ opacity: depositType == 1 ? 1 : 0.5 }"
              @click="depositType = 1"
              >支付宝</el-button
            >
          </div>
          <el-button type="primary" round class="buy-button"
            >立即购买</el-button
          >
        </div>
      </transition>

      <transition name="fade">
        <div class="deposit" v-show="active_in == 2">
          <label>视频直播</label>
          <el-button
            round
            size="small"
            style="margin-left: 20px"
            type="success"
            @click="$message('请下载app入驻')"
            >主播入驻</el-button
          >
          <div>
            <!-- <p style="display: inline-block">
              观看直播请下载APP，当前列表为回放视频
            </p>
            <el-button
              round
              size="small"
              style="margin-left: 20px"
              type="success"
              @click="download_click"
              >下载</el-button> -->
          </div>

          <liveList ref="live"></liveList>
        </div>
      </transition>

      <transition name="fade">
        <div class="deposit" v-show="active_in == 4">
          <ContentList ref="content"></ContentList>
        </div>
      </transition>

      <footer class="footer">
        <p>
          <router-link to="help" class="link">纠纷措施</router-link>|
          <router-link to="server" class="link">用户协议</router-link>
          <!-- <a
            class="link"
            href="http://sq.ccm.gov.cn:80/ccnt/sczr/service/business/emark/toDetail/"
          >
            <img
              style="background: rgba(255,255,255,.7);width:2em;vertical-align:middle;"
              src="@/assets/2121566961709_.pic_hd.jpg"
            /> 鄂网文 (2019) 4540 269号
          </a> -->
        </p>
        <p>联系方式：{{ phone }} 邮箱：{{ mail }}</p>
        <p>地址{{ location }}</p>
        <p>Copyright ©2019 {{ company }}. 版权所有.<a href="https://beian.miit.gov.cn" style="color:#FFF;text-decoration:none;"  target="_blank" >{{ icp }}</a></p>
        <!-- <a style="text-decoration:none;color:#FFF;" href="/网络文化许可证-无毁网络.jpg">网络文化经营许可证</a> -->
      </footer>
    </div>
    <div class="background-right"></div>
  </div>
</template>

<script>
import liveList from './components/live'
import ContentList from './components/content'
import {
  webTitle,
  icp,
  logo,
  downColor,
  bg,
  mobile,
  downurl,
  company,
  location,
  phone,
  mail
} from '../../utils'
import QRCode from 'qrcodejs2'

export default {
  name: 'index',
  components: {
    liveList,
    ContentList
  },
  data () {
    return {
      classify_list: ['文字聊天', '语音聊天', '视频聊天', '游戏', '其他分类'],
      active_in: 0,
      coin_active_pri: -1,
      coin_num: [30, 50, 100, 500, 3000, 5000],
      depositType: -1,
      customCharge: undefined,
      downurl: null,
      chargePhone:""
    }
  },
  methods: {
    download_click () {
      window.location = this.downurl
    }
  },
  mounted () {
    document.title = this.webTitle
    this.downurl = downurl()
    this.$nextTick(() => {
      let qrcode = new QRCode('qrcode', {
        width: 158,
        height: 158, // 高度
        text: this.downurl // 二维码内容
      })
    })
  },
  computed: {
    downColor () {
      return downColor()
    },
    webTitle () {
      return webTitle()
    },
    icp () {
      return icp()
    },
    logo () {
      return logo()
    },
    background () {
      return bg()
    },
    mobile () {
      return mobile()
    },
    location () {
      return location()
    },
    company () {
      return company()
    },
    phone () {
      return phone()
    },
    mail () {
      return mail()
    },
    onIcpClick(){
      location.href="/689501615779249_.pic_hd.jpg"
    },
    coin_active: {
      get: function () {
        return this.coin_active_pri
      },
      set: function (value) {
        if (value !== -2) {
          this.customCharge = undefined
        }
        this.coin_active_pri = value
      }
    }
  },
  watch: {
    active_in (value) {
      this.$refs.live.reset()
      this.$refs.content.reset()
    }
  }
}
</script>

<style lang="scss" scoped>
.fade-enter-active {
  transition: opacity 0.7s;
}
.fade-leave-active {
  transition: opacity 0s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.page {
  text-align: left;
  color: white;
}
.footer {
  padding-top: 50px;
  text-align: center;
  display: block;
  width: 100vw;
  position: absolute;
  bottom: 0;
}
.index-content {
  position: relative;
  left: 15vw;
  width: 50%;
  padding-top: 20vh;
  .iphone {
    padding-top: 15vh;
    height: 75vh;
    max-height: 705px;
    position: absolute;
    left: 55vw;
    top: -5vh;
    transform: translate3d(-50%, 0, 0);
  }
  .qrcode-download {
    display: inline-block;
    width: 158px;
    height: 158px;
    margin-right: 20px;
  }
  .other-download {
    display: inline-block;
    vertical-align: top;
    margin-top: 8px;
    margin-bottom: 8px;
    i {
      font-size: 21px;
    }
  }
  .download-button {
    border: none;
    display: block;
    background: white;
    width: 201px;
    height: 56px;
    border-radius: 28px;
    margin-bottom: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;
    position: relative;
  }
  // .ios-download-icon {
  //   background: url("~@/assets/download_apple@2x.png") no-repeat;
  //   height: 24px;
  //   width: 19px;
  //   display: inline-block;
  //   background-size: 100%;
  //   margin-right: 10px;
  // }
}

.background {
  &-left {
    z-index: -1;
    position: absolute;
    left: 0;
    top: 0;
    background-repeat: no-repeat;
    background-size: 70vw 100%, cover;
    min-height: 100vh;
    width: 100%;
  }
}

.page-content {
  &-button {
    cursor: pointer;
    color: white;
    border: none;
    background: none;
    width: 80px;
    height: 35px;
    margin-right: 85px;
    outline: none;
    text-decoration: none;
    z-index: 100;
    position: relative;
    &-active {
      color: #2395fe;
      background: white;
      border-radius: 17px;
    }
  }
}
.deposit {
  font-size: 1vw;
  margin: auto auto;
  // transform: translate3d(0px, -50%, 0px);
  margin-top: 20vh;
  position: relative;
  color: black;
  padding: 50px;
  background: white;
  // max-height: 65vh;
  width: 60vw;
  z-index: 100;
  &-list {
    color: black;
    display: flex;
    flex-wrap: wrap;
    &-item {
      position: relative;
      outline: none;
      margin-right: 5vw;
      margin-bottom: 2vw;
      text-align: center;
      width: 15vw;
      // max-width: 250px;
      height: 3vw;
      // max-height: 70px;
      line-height: 3vw;
      border-radius: 65px;
      border: 1px solid #979797;
      &-active {
        color: white;
        background: #2395fe;
        border: 1px solid #2395fe;
      }
      &::before {
        content: " ";
        background: url("~@/assets/coin.png") no-repeat;
        display: block;
        height: 3vw;
        width: 3vw;
        transform: translate3d(0, 25%, 0);
        left: 10px;
        position: absolute;
        background-size: 50%;
      }
    }
    &-item:nth-child(3n) {
      margin-right: 0;
    }
    &-custom {
      padding-left: 1rem;
      width: 20vw;
      text-align: left;
    }
  }
  &-phone {
    padding-left: 1rem;
    text-align: left;
    display: block;
  }
  .buy-button {
    margin-top: 20px;
    display: block;
    margin: 40px auto 10px auto;
    width: 20vw;
    max-width: 300px;
  }
}
.link {
  color: white;
  text-decoration: none;
  margin: 0 20px 0;
}
</style>
